
<template>
  <div class="accordion" >
    <div v-for="(category, index) in model.data" :key="index">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1">
          <a v-b-toggle :href="`accordion-${index}`" @click.prevent @click="selectedAccordionIndex = index" variant="info">
            {{ category.name}} - ({{category.knowledgeItemsCount}})
          </a>
        </b-card-header>
        <b-collapse
          @show="onShow(category)"
          :visible="isVisible(index)"
          :id="`accordion-${index}`"
          accordion="accordion-categories" >
          <b-card-body>
            <Grid :ref="`grid-${category.id}`"
                  :service="service"
                  :fetch-on-mounted="false"
                  :route_grid_path="`/categories/${category.id}/items`"
                  :route_name="`/categories/${category.id}/items`">
              <template v-slot:actions="actions">
                <div class="flex flex-row gap-2">
                  <feather-icon
                    v-permission="'knowledge_items.detail'"
                    icon="EyeIcon"
                    class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                    v-tooltip.top="{ content: 'Detalhar', delay: { show: 100, hide: 100 }}"
                    @click="detail(actions.row.id)"/>
                </div>
              </template>
            </Grid>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>


<script>
import KnowledgeService from '@/services/api/KnowledgeService'

import { BButton, BCard, BCardBody, BCardHeader, BCollapse, BCardText, BTable, BSpinner, VBToggle } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
    VBToggle
  },
  components: {
    BButton,
    BCard,
    BCollapse,
    BCardHeader,
    BCardBody,
    BCardText,
    BTable,
    BSpinner
  },
  data: () => ({
    model: {
      current_page: 1,
      data: [],
      last_page: 0,
      next_page_url: '',
      prev_page_url: '',
      to: 10,
      total: 0,
    },
    columns_: {},
    selected: [],
    service: null,
    selectedAccordionIndex: 0,
    grids: {
      fields: ['id', 'title', 'description', 'filesCount', 'actions'],
      dataByCategory: {}
    },
  }),
  methods: {
    detail(id) {
      this.$router.push({
        name: 'knowledge-item-consult-detail',
        params: {
          id: id
        }
      })
    },
    onShow(category) {
      console.log(this.$refs);
      this.$refs[`grid-${category.id}`][0].fetchGridData();
    },
    isVisible(index) {
      return this.selectedAccordionIndex === index;
    },
    setLoadingGrid(categoryId, busy) {
      this.$set(this.$data.grids.dataByCategory[categoryId], 'busy', busy);
    },
    parseGridData(data) {
      let gridData = {};
      data.forEach(category => {
        gridData[category.id] = { busy: false, data: [] };
      });
      return gridData;
    },

  },
  beforeMount() {
    this.service = KnowledgeService.build(this.$vs)
  },



  async mounted() {
    try {
      this.$vs.loading();
      const response = await this.service.getCategoriesGrid();
      const gridData = this.parseGridData(response.model.data);

      this.$set(this.$data.grids, 'dataByCategory', gridData);
      this.$set(this.$data, 'model', response.model);
      this.$set(this.$data, 'columns_', response.columns);

      await this.$nextTick();

      //console.log('calling ',response.model.data[0]);
      this.onShow(response.model.data[0]);

    } catch(e) {
      console.log('erro ao requisitar grid', e);
    } finally {
      this.$vs.loading.close();
    }
  }
}
</script>
